/**
 * Checks if a value is null or undefined.
 * @param value The value to check.
 * @returns `true` if the value is null or undefined, `false` otherwise.
 */
export const isNullOrUndefined = (value: unknown): value is null | undefined =>
	value === null || value === undefined;

export const isSubstringMatch = (value: string, searchText: string): boolean => {
	if (!value || !searchText) {
		return false;
	}
	return value.toLowerCase().includes(searchText.toLowerCase());
};
